import axios from 'axios'
import React, { useState, useEffect, useMemo, Fragment, useRef, forwardRef, useImperativeHandle } from 'react'
import { FormControl, InputLabel, Input, FormHelperText, Alert, Menu } from '@mui/material'
import WebService from '@util/webService'
import { encodeParams, getAction, printVariable, download, comma } from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux'
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/Search'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField, withStyles, InputBase } from '@mui/material'
import { styled, alpha } from '@mui/material/styles'
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton'
import useSnackbar from '@hooks/useSnackbar'
import MyTableHead from '@components/MyTableHead'
import useIndicator from '@hooks/useIndicator'
import Indicator from '@components/Indicator'
import MyDialog from '@components/MyDialog'
import MyDialog2 from '@components/MyDialog2'
import useForm from '@hooks/useForm'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
// pagination
import { useTheme } from '@mui/material/styles'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import LastPageIcon from '@mui/icons-material/LastPage'
import ControlPointIcon from '@mui/icons-material/ControlPoint'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
// date
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import 'dayjs/locale/ko'
import moment from 'moment'
import { Avatar, Grid, Container } from '@mui/material/'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'
import { searchSchool } from '@util/helper'
import useAlert from '@hooks/useAlert'
import ConfirmDialog from '@components/ConfirmDialog'
import { useParams, useLocation } from 'react-router-dom'
import * as ExcelJS from 'exceljs'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
const Boxs = styled(Box)`
  padding-bottom: 40px !important;
`
const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`
const getPhaseName = (phase) => {
  if (+phase === 0) {
    return '학기 준비'
  } else if (+phase === 1) {
    return '모집 시작'
  } else if (+phase === 1.1) {
    return '모집 마감'
  } else if (+phase === 1.11) {
    return '추가모집 시작'
  } else if (+phase === 1.2) {
    return '등록 마감'
  } else if (+phase === 1.3) {
    return '출석부 생성'
  } else if (+phase === 1.4) {
    return '개강'
  } else if (+phase === 2) {
    return '종강'
  }
  return ''
}

const fetchLectures = async (smstId) => {
  const url = `/lecture/smst/${smstId}`
  const resp = await WebService.get(url)
  if (resp.repCode !== 'ack') {
    return
  }
  const repMessage = JSON.parse(resp.repMessage)
  return JSON.parse(repMessage.records)
}

const Menu2 = forwardRef((props, ref) => {
  const { reload } = props
  const [shortLectures, set_shortLectures] = useState([])
  const [anchorEl, set_anchorEl] = useState(null)
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const recordRef = useRef()
  const { alert, renderAlert } = useAlert()
  const handleClose = () => {
    set_anchorEl(null)
  }

  const additionHandler = useState(false)

  const handleOpen = (event) => {
    event.currentTarget.getBoundingClientRect()
    set_anchorEl(event.currentTarget)
  }
  useImperativeHandle(ref, () => ({
    openMenu: (event, row) => {
      recordRef.current = row
      console.log('row.id', row.id)
      handleOpen(event)
    },
    closeMenu: () => {
      handleClose()
    },
  }))

  const onChangeState = async (phase, statCode) => {
    const url = `/smst/phase/${recordRef.current.id}/${phase}/${statCode}`
    openIndicator()
    const resp = await WebService.post(url)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
    } else {
      alert('처리되었습니다.')
      if (reload) {
        reload()
      }
    }
  }

  const onAddition = async () => {
    const smst = recordRef.current
    if (!smst.regiAtime) {
      alert('해당 학기에 추가신청 마감일시가 존재하지 않습니다.')
      return
    }

    let lectures = await fetchLectures(recordRef.current.id)
    if (!lectures) {
      alert('에러가 발생했습니다.')
      return
    }

    lectures = lectures.filter((r) => r.statCode != 'S004')
    const acceptCodes = ['S002', 'T001', 'T002', 'S004', 'S012']
    const rejectLectures = lectures.filter((r) => !acceptCodes.includes(r.statCode))
    if (rejectLectures.length > 0) {
      alert('모든 강좌상태가 [모집 마감/모집 중지/선발 완료/폐강] 상태 중 하나에 해당되어야 추가모집을 할 수 있습니다.')
      return
    }

    const shortLectures = lectures.filter((r) => r.rcrNum > r.reqNum)
    if (shortLectures.length > 0) {
      set_shortLectures(shortLectures)
      additionHandler[1](true)
    } else {
      alert('추가모집 대상 강좌가 없습니다.')
    }
  }

  const onAdminChangeState = async (phase, statCode) => {
    const url = `/smst/admin/phase/${recordRef.current.id}/${phase}/${statCode}`
    openIndicator()
    const resp = await WebService.post(url)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
    } else {
      alert('처리되었습니다.')
      if (reload) {
        reload()
      }
    }
  }
  const hidden = { display: 'none' }
  const btnResetRef = useRef()
  const btnRef1 = useRef()
  const btnRef2 = useRef()
  const btnRef2_2 = useRef()
  const btnRef3 = useRef()
  const btnRef4 = useRef()
  const btnRef5 = useRef()
  const btnRef6 = useRef()
  const btnRef7 = useRef()
  return (
    <>
      <>
        {renderAlert()}

        <ConfirmDialog
          btn={
            <FlatButton ref={btnRef1} style={hidden}>
              모집 시작
            </FlatButton>
          }
          title={'알림'}
          content={'전체강좌를 모집시작 상태로 변경하시겠습니까?'}
          bc={'primary'}
          preHandle={() => {
            return true
          }}
          perform={() => {
            onChangeState(1, 'S001')
          }}
        />
        <ConfirmDialog
          btn={
            <FlatButton ref={btnRef2} style={hidden}>
              모집 마감
            </FlatButton>
          }
          title={'알림'}
          content={'전체강좌를 모집마감 상태로 변경하시겠습니까?'}
          bc={'primary'}
          preHandle={() => {
            return true
          }}
          perform={() => {
            onChangeState(1.1, 'S002')
          }}
        />
        <ConfirmDialog
          btn={
            <FlatButton ref={btnRef3} style={hidden}>
              등록 마감
            </FlatButton>
          }
          title={'알림'}
          content={'전체강좌를 등록마감 상태로 변경하시겠습니까?'}
          bc={'primary'}
          preHandle={() => {
            return true
          }}
          perform={() => {
            onChangeState(1.2, 'S013')
          }}
        />
        <ConfirmDialog
          btn={
            <FlatButton ref={btnRef4} style={hidden}>
              출석부 생성
            </FlatButton>
          }
          title={'알림'}
          content={'전체강좌를 출석부마감/개강준비완료 상태로 변경하시겠습니까?'}
          bc={'primary'}
          preHandle={() => {
            return true
          }}
          perform={() => {
            onChangeState(1.3, 'S014')
          }}
        />
        <ConfirmDialog
          btn={
            <FlatButton ref={btnRef5} style={hidden}>
              개강
            </FlatButton>
          }
          title={'알림'}
          content={'전체강좌를 개강 상태로 변경하시겠습니까?'}
          bc={'primary'}
          preHandle={() => {
            return true
          }}
          perform={() => {
            onChangeState(1.4, 'S003')
          }}
        />
        <ConfirmDialog
          btn={
            <FlatButton ref={btnRef6} style={hidden}>
              종강
            </FlatButton>
          }
          title={'알림'}
          content={'전체강좌를 종강 상태로 변경하시겠습니까?'}
          bc={'primary'}
          preHandle={() => {
            return true
          }}
          perform={() => {
            onChangeState(2, 'S005')
          }}
        />
        <ConfirmDialog
          btn={
            <FlatButton ref={btnResetRef} style={hidden}>
              수강(신청) 데이터 리셋
            </FlatButton>
          }
          title={'주의'}
          content={'수강(신청) 관련 모든 데이터가 삭제 되어 복구할 수 없으며, 학기/강좌는 준비 상태로 됩니다. 실행하시겠습니까? '}
          bc={'error'}
          preHandle={() => {
            return true
          }}
          perform={() => {
            onChangeState(0, 'S000')
          }}
        />
        {
          <ConfirmDialog
            btn={
              <FlatButton ref={btnRef7} style={hidden}>
                개강전 상태로 돌아가기
              </FlatButton>
            }
            title={'알림'}
            content={'전체강좌를 개강전 출석부생성 상태로 변경하시겠습니까?'}
            bc={'primary'}
            preHandle={() => {
              return true
            }}
            perform={() => {
              onAdminChangeState(1.3, 'S014')
            }}
          />
        }
      </>
    </>
  )
})

const Menu3 = forwardRef((props, ref) => {
  const { reload } = props
  const [anchorEl, set_anchorEl] = useState(null)
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const recordRef = useRef()
  const { alert, renderAlert } = useAlert()
  const schola = useSelector((state) => state.scholaReducer)
  const handleClose = () => {
    set_anchorEl(null)
  }

  const handleOpen = (event) => {
    event.currentTarget.getBoundingClientRect()
    set_anchorEl(event.currentTarget)
  }
  useImperativeHandle(ref, () => ({
    openMenu: (event, row) => {
      recordRef.current = row
      console.log('row.id', row.id)
      handleOpen(event)
    },
    closeMenu: () => {
      handleClose()
    },
  }))

  const handleDownloadOld = async (gubun) => {
    console.log('downloading...')
    const url = `/smst/export/bill/${recordRef.current.id}/${gubun}`
    await download(url)
  }

  const handleDownload = async (gubun) => {
    const url = `/smst/export/bill/${recordRef.current.id}/${gubun}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const billArray = JSON.parse(repMessage.billArray)
    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet(`${recordRef.current.year}_${recordRef.current.gisu}`)

    billArray.forEach((row, rowIdx) => {
      const formattedRow = row.map((value, colIdx) => {
        if (+gubun === 1 && rowIdx > 0 && colIdx >= 9 && colIdx <= 15) {
          return comma(value)
        } else if (+gubun === 2 && rowIdx > 0 && colIdx >= 6 && colIdx <= 12) {
          return comma(value)
        } else {
          return value
        }
      })

      worksheet.addRow(formattedRow)
    })

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' })
      let filename = `${schola.name}_${recordRef.current.year}_${recordRef.current.gisu}_결제정보`
      if (+gubun === 1) {
        filename = filename + `(강좌별)`
      } else if (+gubun === 2) {
        filename = filename + `(학생별)`
      }
      filename = filename + `.xlsx`

      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
  }

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column' }} onClick={handleClose}>
          <FlatButton variant="text" onClick={() => handleDownload(1)}>
            강좌별
          </FlatButton>

          <FlatButton variant="text" onClick={() => handleDownload(2)}>
            학생별
          </FlatButton>
        </Box>
      </Menu>
    </>
  )
})

const TeacherSmstPage = () => {
  console.log('ManagerSmstPage rendering...')
  const location = useLocation()
  const curLocationRef = useRef(location)
  const { more } = useParams()
  const inputRef = useRef(null)
  const dateFormat = 'YYYY-MM-DD HH:mm:ss'
  const [detailScreen, set_detailScreen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const fields = [
    { field: 'id', placeholder: '학기ID', type: 'text', value: -1, visible: more && more === 'more', canSrch: false, selList: [] },
    { field: 'phase', placeholder: '단계', type: 'text', value: -1, visible: more && more === 'more', canSrch: false, selList: [] },
    { field: 'schoolId', placeholder: '학교ID', type: 'text', value: '', visible: false, canSrch: false, selList: [] },
    { field: 'schoolName', placeholder: '학교명', type: 'locked', value: '', visible: detailScreen, canSrch: false, selList: [] },
    { field: 'year', placeholder: '년도', type: 'year', value: null, visible: true, canSrch: false, selList: [] },
    { field: 'gisu', placeholder: '기수', type: 'text', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'prevGisu', placeholder: '이전기수', type: 'text', value: '', visible: !detailScreen, canSrch: false, selList: [] },
    { field: 'prevId', placeholder: '이전기수', type: 'text', value: '', visible: detailScreen, canSrch: false, selList: [] },
    { field: 'selCode', placeholder: '선발방식', type: 'text', value: '', visible: false, canSrch: false, selList: [] },
    { field: 'regiTime', placeholder: '수강신청', type: 'date', value: null, visible: true, canSrch: false, selList: [] },
    { field: 'regiStime', placeholder: '수강신청 시작', type: 'date', value: null, visible: false, canSrch: false, selList: [] },
    { field: 'regiStime1', placeholder: '수강신청 시작일', type: 'date', value: null, visible: false, canSrch: false, selList: [] },
    { field: 'regiStime2', placeholder: '수강신청 시작일', type: 'date', value: null, visible: false, canSrch: false, selList: [] },
    { field: 'regiEtime', placeholder: '수강신청 종료', type: 'date', value: null, visible: false, canSrch: false, selList: [] },
    { field: 'regiEtime1', placeholder: '수강신청 종료일', type: 'date', value: null, visible: false, canSrch: false, selList: [] },
    { field: 'regiEtime2', placeholder: '수강신청 종료일', type: 'date', value: null, visible: false, canSrch: false, selList: [] },
    { field: 'regiFtime', placeholder: '수강신청 확정', type: 'date', value: null, visible: false, canSrch: false, selList: [] },
    { field: 'regiFtime1', placeholder: '수강신청 확정일', type: 'date', value: null, visible: false, canSrch: false, selList: [] },
    { field: 'regiFtime2', placeholder: '수강신청 확정일', type: 'date', value: null, visible: false, canSrch: false, selList: [] },
    { field: 'regiAtime', placeholder: '추가모집 종료', type: 'date', value: null, visible: true, canSrch: false, selList: [] },
    { field: 'regiAtime1', placeholder: '추가모집 종료일', type: 'date', value: null, visible: false, canSrch: false, selList: [] },
    { field: 'regiAtime2', placeholder: '추가모집 종료일', type: 'date', value: null, visible: false, canSrch: false, selList: [] },
    { field: 'lectureTime', placeholder: '강좌', type: 'date', value: null, visible: true, canSrch: false, selList: [] },
    { field: 'lectureStime', placeholder: '강좌', type: 'date', value: null, visible: false, canSrch: false, selList: [] },
    { field: 'lectureEtime', placeholder: '강좌 종료', type: 'date', value: null, visible: false, canSrch: false, selList: [] },
    { field: 'elseInfo', placeholder: '기타정보', type: 'text', value: 'Y', visible: true, canSrch: false, selList: [] },
    { field: 'autoYn', placeholder: '자동 절차', type: 'text', value: 'Y', visible: false, canSrch: false, selList: [] },
    { field: 'allsYn', placeholder: '수강신청일정 검사', type: 'text', value: 'Y', visible: false, canSrch: false, selList: [] },
    { field: 'consentYn', placeholder: '수강신청동의서 받기', type: 'text', value: 'N', visible: false, canSrch: false, selList: [] },
    { field: 'phaseName', placeholder: '최근수행', type: 'text', value: -1, visible: true, canSrch: false, selList: [] },
  ]
  const theme = useTheme()
  const btnRef = useRef(null)
  const visibleColumns = fields.filter((col) => col.visible)
  const defRecord = {}
  const dgRef = useRef()
  fields.forEach((d) => {
    defRecord[d.field] = d.value
  })
  defRecord.schoolList = []
  const defTerms = {}
  fields
    .filter((col) => col.canSrch)
    .map((d) => d.field)
    .forEach((d) => (defTerms[d] = ''))
  const [record, set_record] = useState(defRecord)
  const [dataList, set_dataList] = useState([])
  const [skipPageReset, setSkipPageReset] = React.useState(false)
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const { alert, renderAlert } = useAlert()
  const [selIdx, set_selIdx] = useState(-1)
  const [pageNum, set_pageNum] = useState(0)
  const [pageSize, set_pageSize] = useState(10)
  const [totalCount, set_totalCount] = useState(0)
  const [pageInfo, set_pageInfo] = useState({ pageNum: 0, pageSize: 10 })
  const [terms, _set_terms] = useState(defTerms)
  const [fontSize, set_fontSize] = useState(12)
  const termsRef = useRef(terms)
  const [schoolGroup, set_schoolGroup] = useState([])
  // redux
  const codeGroups = useSelector((state) => state.codeGroupReducer)
  const codes = useSelector((state) => state.codeReducer)
  const schools = useSelector((state) => state.schoolReducer)
  const account = useSelector((state) => state.accountReducer)
  const schola = useSelector((state) => state.scholaReducer)

  const selCodes = codes.filter((r) => r.codeGroupId === 'SA07')
  const overCodes = codes.filter((r) => r.codeGroupId === 'SC07')
  //
  const recordRef = useRef(defRecord)
  const set_terms = (data) => {
    termsRef.current = data
    _set_terms(data)
  }
  const menuRef2 = useRef()
  const menuRef3 = useRef()

  const splitDateTime = (datetime) => {
    if (!datetime) {
      return
    }
    const parsedDateTime = moment(datetime)
    const date = parsedDateTime.format('YYYY-MM-DD 00:00:00')
    const hour = parsedDateTime.format('HH')
    const min = parsedDateTime.format('mm')
    const sec = parsedDateTime.format('ss')
    return { date: date, hour: hour, min: min, sec: sec }
  }

  const fetchLectures = async (smstId) => {
    const url = `/lecture/smst/${smstId}`
    const resp = await WebService.get(url)
    if (resp.repCode !== 'ack') {
      openSnackbar(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    return JSON.parse(repMessage.records)
  }

  const fetchSmst = async () => {
    const url = `/smst/last/1/${schola.id}`
    const resp = await WebService.get(url)
    if (resp.repCode !== 'ack') {
      openSnackbar(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const smsts = JSON.parse(repMessage.records)
    if (smsts.length == 0) {
      return
    }
    return smsts[0]
  }

  const onLoad = async () => {
    const schoolId = schola.hasOwnProperty('id') ? schola.id : -1
    let url = `/smst/${schoolId}`
    const newTerms = {}
    Object.keys(termsRef.current).forEach((key) => {
      if (termsRef.current[key] !== '') {
        newTerms[key] = termsRef.current[key]
      }
    })
    let tempList
    openIndicator()
    let resp = await WebService.get(url, { pageNum: pageInfo.pageNum, pageSize: pageInfo.pageSize, terms: JSON.stringify(newTerms) })
    closeIndicator()
    if (resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      const totalCount = repMessage.totalCount
      set_totalCount(totalCount)
      records.forEach((r) => {
        r.isDetail = false
        // split date, hour
        const regiStime = splitDateTime(r.regiStime)
        r.regiStime1 = regiStime.date
        r.regiStime2 = regiStime.hour

        const regiEtime = splitDateTime(r.regiEtime)
        r.regiEtime1 = regiEtime.date
        r.regiEtime2 = regiEtime.hour

        const regiFtime = splitDateTime(r.regiFtime)
        r.regiFtime1 = regiFtime.date
        r.regiFtime2 = regiFtime.hour

        const regiAtime = splitDateTime(r.regiAtime)
        r.regiAtime1 = regiAtime?.date ?? null
        r.regiAtime2 = regiAtime?.hour ?? null

        r.phaseName = getPhaseName(r.phase)
        r.prevGisu = records.find((r2) => r.prevId === r2.id)?.gisu

        r.selCodeName = selCodes.find((r2) => r2.code === r.selCode)?.name
        r.overCodeName = overCodes.find((r2) => r2.code === r.overCode)?.name
      })
      // set_dataList(records)
      tempList = records
    }
    tempList.forEach((st) => {
      const found = schools.find((d) => d.id === st.schoolId)
      if (found) {
        st.schoolName = found.name
      }
    })
    const schoolGroup = tempList.reduce((acc, cur) => {
      if (acc[cur.schoolId]) {
        acc[cur.schoolId].push(cur)
      } else {
        acc[cur.schoolId] = [cur]
      }
      return acc
    }, {})
    set_schoolGroup(schoolGroup)
    set_dataList(schoolGroup)
  }

  const onDetail = async (id) => {
    recordRef.current.isNew = false
    set_detailScreen(true)
    dgRef.current.open()
  }

  const onDownload = async (id) => {}
  const onDelete = async (id) => {
    const url = '/smst'
    const resp = await WebService.delete(url, { id: id, schoolId: schola.id })
    if (resp.repCode === 'ack') {
      onLoad()
      openSnackbar('삭제되었습니다.')
    } else {
      openSnackbar(resp.repMessage)
    }
  }

  const preDelete = async (id) => {
    const lectures = await fetchLectures(id)
    if (!lectures) {
      alert('에러가 발생했습니다.')
      return false
    }
    if (lectures.length > 0) {
      alert('학기에 강좌가 등록되어 있어 삭제할 수 없습니다.')
      return false
    }
    return true
  }

  const onCreate = async () => {
    /*
		const smst = await fetchSmst()
		if (smst) {
      // if(Math.floor(smst.phase) === 1) {
      //   const regiFtime = moment(smst.regiFtime, dateFormat)
      //   
      //   const now = moment()
      //   if (now.isBefore(regiFtime)) {
      //     alert("마지막 학기가 수강신청이 종료되지 않아 새로운 학기를 생성할 수 없습니다.")
      //     return
      //   }
      // }
     
      if(smst.phase < 1.2 ) {
        // alert('기존 학기가 개강 전 상태여서 새로운 학기를 생성할 수 없습니다.')
        alert('기존 학기가 모집마감 되지 않아 새로운 학기를 생성할 수 없습니다.')
        return
      }
		}
    */
    const now = moment().format(dateFormat)
    const newRecord = { ...defRecord, schoolId: schola.id, phase: 0, prevId: 0, regTime: now, uptTime: now, overCode: 'V001', schoolRltnList: [] }
    newRecord.guardian = {}
    newRecord.regiAndLectureList = []
    recordRef.current = newRecord
    set_detailScreen(true)
    dgRef.current.open()
  }

  const onCopy = async () => {
    const now = moment().format(dateFormat)
    const newRecord = {
      ...defRecord,
      schoolId: schola.id,
      phase: 0,
      prevId: 0,
      regTime: now,
      uptTime: now,
      schoolRltnList: [],
      overCode: 'V001',
      copy: recordRef.current,
    }
    newRecord.guardian = {}
    newRecord.regiAndLectureList = []
    recordRef.current = newRecord
    set_detailScreen(true)
    dgRef.current.open()
  }

  const onSearch = () => {
    onLoad()
  }
  const onClear = () => {
    const obj = {}
    Object.keys(terms).forEach((k) => {
      obj[k] = ''
    })
    set_terms(obj)
  }
  const handleChangePage = (event, newPage) => {
    set_pageInfo({ ...pageInfo, pageNum: newPage })
  }
  const handleChangeRowsPerPage = (event) => {
    const pageSize = parseInt(event.target.value, 10)
    set_pageInfo({ pageNum: 0, pageSize: pageSize })
  }
  const TablePaginationActions = (props) => {
    const theme = useTheme()
    const { count, page, rowsPerPage, onPageChange } = props
    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0)
    }
    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1)
    }
    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1)
    }
    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
    }
    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="next page">
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="last page">
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    )
  }
  const handleMenuClick = (event, row) => {
    event.currentTarget.getBoundingClientRect()
    setAnchorEl(event.currentTarget)
  }
  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleDownload2 = async (smstId, gubun) => {
    console.log(`downloading... ${smstId}`)
    const url = `/smst/export/lecture/${smstId}`
    await download(url)
  }

  useEffect(() => {
    if (curLocationRef.current.key !== location.key) {
      curLocationRef.current = location
      set_pageInfo({ pageNum: 0, pageSize: 10 })
    }
  }, [location])

  useEffect(() => {
    onLoad()
  }, [pageInfo])

  useEffect(() => {
    const size = window.getComputedStyle(inputRef.current, null).getPropertyValue('font-size')
    set_fontSize(size)
  }, [])
  const dg_title = '학기 정보'

  if (dataList != null) {
    return (
      <div ref={inputRef}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <div style={{ paddingRight: 10 }}>
            <h1>학기 목록 </h1>
          </div>
        </div>
        <div style={{ paddingTop: 20 }}>
          <MUITable sx={{ minWidth: 1200 }}>
            <MyTableHead>
              <TableRow>
                {fields.map((col, index) => {
                  if (col.visible) {
                    return (
                      <TableCell key={index} size="small" key={col.field}>
                        {col.placeholder}
                        {col.canSrch ? (
                          <Fragment>
                            <TextField
                              label=""
                              variant="outlined"
                              size="small"
                              inputProps={{ style: { fontSize: '0.875em', padding: 5, backgroundColor: '#fff' } }}
                              value={terms[col.field]}
                              onChange={(e) => {
                                const newTerms = { ...terms }
                                newTerms[col.field] = e.target.value
                                set_terms(newTerms)
                              }}
                            />
                          </Fragment>
                        ) : (
                          <Fragment></Fragment>
                        )}
                      </TableCell>
                    )
                  }
                })}

              </TableRow>
            </MyTableHead>
            <TableBody>
              {Object.keys(dataList).map((schoolId) => {
                return (
                  <Fragment>
                    {dataList[schoolId].map((row, ridx) => {
                      return (
                        <TableRow
                          key={ridx}
                          onMouseEnter={() => {
                            recordRef.current = row
                          }}
                        >
                          {fields.map((col, cidx) => {
                            if (col.visible && col.field !== 'schoolName') {
                              // if(col.field === 'regiStime' || col.field === 'regiEtime' || col.field === 'regiFtime' || col.field === 'lectureStime' || col.field ==='lectureEtime') {
                              if (col.field === 'lectureTime' || col.field === 'lectureEtime') {
                                return (
                                  <TableCell key={cidx} size="small">
                                    <Typography variant="body2" fontWeight={col.field === 'gisu' ? 'bold' : 'normal'} fontSize={'0.9em'}>
                                      시작일: {row.lectureStime.substr(0, 10)} <br />
                                      종료일: {row.lectureEtime.substr(0, 10)}
                                    </Typography>
                                  </TableCell>
                                )
                              }
                              // else if (col.field === "regiStime" || col.field === "regiFtime" || col.field === "regiEtime" || col.field === 'regiAtime') {
                              else if (col.field === 'regiTime') {
                                return (
                                  <TableCell key={cidx} size="small">
                                    <Typography variant="body2" fontWeight={col.field === 'gisu' ? 'bold' : 'normal'} fontSize={'0.9em'}>
                                      시작일시: {row.regiStime} <br />
                                      종료일시: {row.regiEtime} <br />
                                      확정일시: {row.regiFtime}
                                    </Typography>
                                  </TableCell>
                                )
                              } else if (col.field === 'elseInfo') {
                                return (
                                  <TableCell key={cidx} size="small">
                                    <Typography variant="body2" fontWeight={col.field === 'gisu' ? 'bold' : 'normal'} fontSize={'0.9em'}>
                                      자동절차: {row.autoYn} <br />
                                      수강신청중복일정검사: {row.allsYn} <br />
                                      선발방식(강좌별 설정 가능): {row.selCodeName}
                                      {row.selCode === 'S001' ? (
                                        <>
                                          <br />
                                          기수강자우선일 경우 모집정원 초과시 선발방식: {row.overCodeName}
                                        </>
                                      ) : null}
                                    </Typography>
                                  </TableCell>
                                )
                              } else {
                                return (
                                  <TableCell key={cidx} size="small">
                                    <Typography variant="body2" fontSize={'0.9em'}>
                                      {row[col.field]}
                                    </Typography>
                                  </TableCell>
                                )
                              }
                            }
                          })}
                        </TableRow>
                      )
                    })}
                  </Fragment>
                )
              })}
            </TableBody>
            <TableFooter></TableFooter>
          </MUITable>
          <Menu2 ref={menuRef2} reload={onLoad} />
          <Menu3 ref={menuRef3} reload={null} />
          {renderIndicator()}
          {renderAlert()}
        </div>
      </div>
    )
  }
}
export default TeacherSmstPage
